<template>
    <div class="main bg-g-white-transparent">
        <div class="d-flex position-sticky align-items-center flex-column flex-lg-row">
            <SearchBar />
        </div>
        <section id="brn-blog-posts">
            <div class="title">
                <ChalkDecoration class="mx-auto my-4">
                    <h2>Blog</h2>
                </ChalkDecoration>
            </div>
            <div v-if="filterPosts.length" class="container">
                <div class="row">
                    <div v-for="post in posts" class="col-lg-4 col-md-6 col-sm-12">
                        <BlogPostCard
                            :key="post.id"
                            :post="post"
                            :page-slug="getPageSlugByLayout('post')"/>
                    </div>

                </div>
            </div>
            <div v-else class="flex-grow-1 text-center mt-5">
                <h3>Posts {{ keyword.length ? 'for «' + keyword + '»' : '' }}not found </h3>
            </div>
            <div class="d-flex justify-content-between">
                <Paginator
                    :links="meta.links"
                    @change-page="changePage"
                    class="mx-auto my-4"
                />
            </div>
        </section>

    </div>
</template>

<script>
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import SettingsMixin from "../../mixins/SettingsMixin";
import GoogleMap from "../components/elements/GoogleMap";
import ApiRequest from "../../utils/api-request";
import SearchBar from "../components/elements/SearchBar";
import BlogPostCard from "../components/cards/BlogPostCard";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import Paginator from "../components/Paginator";
export default {
    name: "Blog",
    components: {Paginator, ChalkDecoration, BlogPostCard, SearchBar, GoogleMap},
    mixins: [PageLayoutContentMixin, SettingsMixin],
    data() {
        return {
            posts: [],
            meta: {},
            page: 1
        }
    },
    computed: {
        keyword: {
            get: function () {
                return this.$store.getters['filter/keyword']
            },
            set: function (value) {
                this.$store.commit('filter/SET_KEYWORD', value)
            }
        },
        filterPosts() {
            return this.keyword ? this.posts?.filter(a => a.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1) : this.posts;
        }
    },
    methods: {
        fetchPosts() {
            new ApiRequest().getBlogPosts(this.page).then(response => {
                this.posts = response.data.data;
                this.meta = response.data.meta;
            });
        },
        changePage(page) {
            this.page = page;
            this.fetchPosts();
        }
    },
    mounted() {
        this.fetchPosts();
    }
}
</script>

<style scoped>

</style>
